export function formatBlogDate(timestamp, options = { day: 'numeric', month: 'short', year: 'numeric' }) {
  if (!timestamp) return '';
  const date = timestamp.toDate
    ? timestamp.toDate()
    : timestamp.seconds
      ? new Date(timestamp.seconds * 1000)
      : new Date(timestamp);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-US', options);
}

export function stripHtml(html) {
  if (!html) return '';
  return html.replace(/<[^>]*>?/gm, '');
}

export function getPostTitle(post) {
  return post?.seo?.title || post?.title || '';
}

export function getSnippet(post, maxLength = 120) {
  if (post?.seo?.description) return post.seo.description;
  const plainText = stripHtml(post?.content || '');
  if (plainText.length <= maxLength) return plainText;
  return `${plainText.substring(0, maxLength)}...`;
}

export function getReadingTime(content) {
  if (!content) return '1 min read';
  const wordCount = stripHtml(content).split(/\s+/).filter(Boolean).length;
  const minutes = Math.max(1, Math.ceil(wordCount / 200));
  return `${minutes} min${minutes !== 1 ? 's' : ''} read`;
}

export function getMetaKeywords(posts) {
  const keywords = new Set();
  posts.forEach((post) => {
    if (post.seo?.keywords) {
      post.seo.keywords.split(',').forEach((kw) => {
        const trimmed = kw.trim();
        if (trimmed) keywords.add(trimmed);
      });
    }
  });
  return Array.from(keywords).join(', ');
}

export function getMetaDescription(content, maxLength = 160) {
  const plainText = stripHtml(content);
  if (plainText.length <= maxLength) return plainText;
  return `${plainText.substring(0, maxLength)}...`;
}
